exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warningDialog{max-width:400px}.warningDialog .warning-dialog-title{font-size:18px;padding-bottom:10px}.warningDialog .modal-footer{background-color:#f2f2f2}\n", ""]);

// exports
